import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectSchemaAttributes } from 'services/schemaAttributes/selectors';

// Utils
import orderBy from 'utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface Props {
    schemaId: number;
}

const selectSchemaId = (state: any, props: Props) => props.schemaId;

const selectData = createDeepEqualSelector(
    selectSchemaAttributes,
    schemaAttributesState => Object.values(schemaAttributesState)
);

const selectFilteredData = createDeepEqualSelector(
    [selectData, selectSchemaId],
    (dataState, schemaIdState) =>
        dataState.filter(value => value.schemaId === schemaIdState)
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'orderIndex')
);

const selectIds = createDeepEqualSelector(selectOrderedData, orderedDataState =>
    orderedDataState.map(value => value.id)
);

export { selectData, selectFilteredData, selectOrderedData, selectIds };
